export const save  = (grid) => {
    let cells = [];

    for (let i=0; i < grid.size; i++) {
        cells.push([... grid.cells[i]]);
    }

    grid.savedCells = cells;
};

export const restore = (grid) => {
    if (grid.savedCells) {
        grid.cells = [... grid.savedCells];
        save(grid);
        grid.calculateRules();
        grid.updateRedux();
    }
};
